export function scrollintoview(node: HTMLElement): void {
  // TODO: test on Safari
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
  node.scrollIntoView(false);
}
